/* Utilidad compartida */
function getCartAttributesAsObject(attributesArray) {
  if (!attributesArray) return {};
  return attributesArray.reduce((acc, attr) => {
    acc[attr.key] = attr.value;
    return acc;
  }, {});
}

/* Create Minicart */
/* -------------------------------------------------------------------------------------- */
async function addMiniCart(show = true) {
  await window.CartAPI.fetchCart();
  const cart = window.CartAPI.cartData;

  if (!cart) return;

  if (show) {
    $(".c-cart-pop-mini").addClass("active");
  }
  
  $(".js-cart-items").empty();
  
  if (cart.totalQuantity) {
    $(".js-cart-empty").removeClass("active");
    $(".js-cart-items").addClass("active");
    $(".js-cart-min-count-cart").addClass("active");
    $(".js-cart-min-view-header").addClass("active");
    
    let iNote = cart.note || "";
    let suma = 0;
    
    const lines = cart.lines.edges.map(edge => edge.node);
    const iTotal = new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(cart.cost.subtotalAmount.amount);


    for (let i = 0; i < lines.length; i++) {
      const item = lines[i];
      const props = getCartAttributesAsObject(item.attributes);
      
      const category = props._category || '';
      let iUrl = `/products/${item.merchandise.product.handle}`;
      
      if(location.hostname.includes('allnutrition.cl') && category && category !== '' && category !== 'nutrition') {
        iUrl = `https://${category}.allnutrition.cl${iUrl}`;
      }
      
      const iName = item.merchandise.product.title;
      const iTitle = item.merchandise.title
      const iId = item.merchandise.id.split('/').pop(); 
      const ikey = item.id; 
      const iImg = item.merchandise.image?.url || '';
      const iQuantity = item.quantity;
      
      const linePriceFloat = parseFloat(item.cost.totalAmount.amount); 
      const subtotalFloat = parseFloat(cart.cost.subtotalAmount.amount);
      
      const iPrice = new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(linePriceFloat / iQuantity); 

      const iOptions = item.merchandise.product?.variants?.edges?.map(edge => edge.node.product.selectedOrFirstAvailableVariant.selectedOptions).flat() || [];
      
      const iPropertiesCompare = props["productCompare"] || "";
      const iPropertiesCompareTotal = iPropertiesCompare ? parseFloat(iPropertiesCompare) * iQuantity : 0;
      const iPropertiesTag = props["productTagDiscount"] || "";
      
      const iPriceCompareTotal = new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(iPropertiesCompareTotal / 100); 

      const iProductFree = props.productFree !== undefined;
      const iProductPromo = props.promoProducts == undefined ? "" : props.promoProducts;

      // Descuentos
      if ((iPropertiesCompareTotal / 100) >= linePriceFloat) {
        let iDiscountItem = (iPropertiesCompareTotal / 100) - linePriceFloat;
        suma = suma + iDiscountItem;
        $(".js-cart-content-discounts").addClass("active");
      }

      // 1. Construir HTML de Opciones (Variantes)
      let iOptionsHTML = `
            <div class="c-cart-pop-mini__data-variant mb-p10">
              <span>${iOptions[0].name}:</span> ${iTitle}
            </div>
          `;
      // for (let j = 0; j < iOptions.length; j++) {
      //   if (iOptions[j].name !== "Title" || iOptions[j].value !== "Default Title") {
      //     iOptionsHTML += `
      //       <div class="c-cart-pop-mini__data-variant mb-p10">
      //         <span>${iOptions[j].name}:</span> ${iOptions[j].value}
      //       </div>
      //     `;
      //   }
      // }
      

      // 2. Construir HTML de Precios y Tags
      const hasComparePrice = iPropertiesCompare !== "" && !iProductFree;
      const classPrice = `
        <p class="c-cart-pop-mini__data-old-price mb-p0 ${hasComparePrice ? '' : 'd-none'}">
          ${iPriceCompareTotal}
        </p>
      `;
      
      const hasTag = iPropertiesTag !== "" && !iProductFree;
      const classTag = `
        <span class="c-cart-pop-mini__data-discount ${hasTag ? '' : 'd-none'}">
          ${iPropertiesTag}${hasTag ? '%' : ''}
        </span>
      `;

      const iPriceHTML = `
        <div class="c-cart-pop-mini__price ${iProductFree ? 'free-item__price' : ''}">
          ${classPrice}
          <p class="d-flex align-items-center ${!iProductFree ? 'mb-p15' : ''}">
            <span class="c-cart-pop-mini__data-price ${!iProductFree ? 'h5' : 'h4'}">
              ${!iProductFree ? iPrice : 'GRATIS'}
            </span>
            ${classTag}
          </p>
        </div>
      `;

      // 3. Construir el Template Principal (tmpl)
      let tmpl = "";

      if (!iProductFree) {
        tmpl = `
          <div class="c-cart-pop-mini__list-item js-cart-min-item" data-product-id="${iId}" data-line-id="${ikey}" data-product-quantity="${iQuantity}" data-product-promo="${iProductPromo}">
            <div class="row">
              <div class="col-4">
                <a href="${iUrl}">
                  <div class="c-cart-pop-mini__image" style="background: url('${iImg}') center center no-repeat; background-size: contain;"></div>
                </a>
              </div>
              <div class="col-8">
                <div class="c-cart-pop-mini__details">
                  <a class="link link--not-decoration mb-p10" href="${iUrl}">
                    <p class="c-cart-pop-mini__data-title mb-p0">${iName}</p>
                  </a>
                  ${iOptionsHTML}
                  ${iPriceHTML}
                </div>
                <a class="c-cart-pop-mini__close-item js-cart-min-remove" data-line-id="${ikey}" title="close" style="cursor: pointer;">
                  <svg class="icon icon-remove" width="30px" height="30px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Assets" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="icono_eliminar">
                        <g id="Group_2634" transform="translate(7.000000, 5.000000)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.16666667">
                          <path d="M9.167,4 L0.833,4 C0.37294682,4 0,4.37294682 0,4.833 L0,11.5 C0,12.880712 1.1192881,14 2.5,14 L7.5,14 C8.1630415,14 8.798926,13.7366077 9.267767,13.267767 C9.7366077,12.798926 10,12.1630415 10,11.5 L10,4.833 C10,4.37294682 9.627053,4 9.167,4 Z"></path>
                          <path d="M8,2 L7.2759998,0.553 C7.10673644,0.214270592 6.7606658,0.000202218172 6.3819998,0 L3.61800002,0 C3.23933426,0.000202218172 2.89326356,0.214270592 2.72400002,0.553 L2,2 L8,2 Z"></path>
                          <path d="M3.333,7.333 L3.333,10.666 M6.667,7.333 L6.667,10.666 M8,2 L10,2 M2,2 L0,2"></path>
                        </g>
                        <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                      </g>
                    </g>
                  </svg>
                </a>
              </div>
              <div class="col-12">
                <div class="c-cart-pop-mini__quantity-wrapper">
                  <div class="c-mini-quantity__wrapper">
                    <quantity-input class="c-mini-quantity js-add-minicart-quantity">
                      <button class="c-quantity__button no-js-hidden" name="minus" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2" width="12" height="12">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                        </svg>
                      </button>
                      <input class="c-mini-quantity__input js-quantity-input" type="number" name="updates[]" value="${iQuantity}" min="0" id="Quantity-${i}" data-index="1">
                      <button class="c-quantity__button no-js-hidden" name="plus" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10" width="12" height="12">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                        </svg>
                      </button>
                    </quantity-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
      } else {
        // Template para el producto de regalo (Free Item)
        tmpl = `
          <div class="c-cart-pop-mini__list-item free-item__mini js-cart-min-item" data-line-id="${ikey}" data-product-free="${props.productFree}" data-product-id="${iId}" data-product-quantity="${iQuantity}">
            <div class="row">
              <div class="col-12">
                <div class="c-cart-pop-mini__details free-prod">
                  <a class="link link--not-decoration" href="${iUrl}">
                    <p class="c-cart-pop-mini__data-title mb-p0">${iName}</p>
                  </a>
                  <div class="c-cart-pop-mini__data-variant mb-p10">
                    <span>Variante:</span> i
                  </div>
                  ${iOptionsHTML}
                  ${iPriceHTML}
                  <input disabled class="c-mini-quantity__input js-quantity-input" type="number" name="updates[]" value="${iQuantity}" min="0" id="Quantity-${i}" data-index="1">
                </div>
              </div>
            </div>
          </div>
        `;
      }
      
      // Inyectar al DOM
      $(tmpl).appendTo(".js-cart-items");
    }
    
    // Asignar los totales fuera del loop
    $(".js-cart-total").text(iTotal);
    $(".js-cart-min-view-cart").text(`${cart.totalQuantity} Artículo${cart.totalQuantity > 1 ? 's' : ''}`);
    $("[data-cart-notes]").val(iNote);
    
    $(".js-cart-discount-total").text(
      new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(suma)
    );
    
  } else {
    // Carrito vacío
    let subtotalAmount = parseFloat(cart.cost?.subtotalAmount?.amount || 0);
    $(".js-cart-total").text(subtotalAmount);
    $(".js-cart-empty").addClass("active");
    $(".js-cart-items").removeClass("active");
    $(".js-cart-min-count-cart").removeClass("active");
    $(".js-cart-content-discounts").removeClass("active");
    $(".js-cart-min-view-header").removeClass("active");
    $(".js-cart-min-view-cart").text(`${cart.totalQuantity} Artículo${cart.totalQuantity > 1 ? 's' : ''}`);
  }
  
  $("[data-cart-count-bubble]").removeClass("d-none");
  $("[data-cart-count]").text(cart.totalQuantity);
  $("[data-cart-count-bubble-total]").text(parseFloat(cart.cost?.subtotalAmount?.amount || 0));
}

async function updateMiniCartLine(lineId, newQuantity, productId = null, promoProducts = null) {
  try {
    // Validar que la cantidad sea válida
    if (newQuantity < 0) return;
    
    // Actualizar usando GraphQL
    await window.CartAPI.updateLines([{
      id: lineId,
      quantity: newQuantity
    }]);
    
    // Si hay productos promocionales, actualizarlos también
    if (productId && promoProducts) {
      await updateFreeProductQuantitiesMiniCart(productId, promoProducts, newQuantity);
    }
    
    // Re-renderizar el minicart sin mostrarlo de nuevo
    await addMiniCart(false);
  } catch (error) {
    console.error("Error updating cart line:", error);
  }
}

async function updateFreeProductQuantitiesMiniCart(parentProductID_numeric, promos, quantity) {
  if (!promos) return;
  
  let promoProds = promos.split(",");
  const cart = window.CartAPI.cartData;
  const items = cart.lines.edges.map(edge => edge.node);
  
  let linesToUpdate = [];

  promoProds.forEach((idProductFree_numeric) => {
    const free_gid = `gid://shopify/ProductVariant/${idProductFree_numeric}`;
    
    // Buscamos la línea que es de regalo Y pertenece a este producto padre
    let cartItem = items.find(item => {
      const isCorrectVariant = item.merchandise.id === free_gid;
      const hasParentAttr = item.attributes.some(attr => attr.key === "productFree" && attr.value === String(parentProductID_numeric));
      return isCorrectVariant && hasParentAttr;
    });

    if (cartItem) {
      linesToUpdate.push({
        id: cartItem.id,
        quantity: quantity
      });
    }
  });

  if (linesToUpdate.length > 0) {
    await window.CartAPI.updateLines(linesToUpdate);
  }
}

async function updateMiniCart(newQuantity, lineId, productId, promoProducts, actualizar, event) {
  console.log('updateMiniCart called:', { newQuantity, lineId, productId, promoProducts, actualizar, event });
  await updateMiniCartLine(lineId, newQuantity, productId, promoProducts);
}

/* ====================================================================================== */
/* Event Listeners para botones del minicart */
/* ====================================================================================== */

// Event delegation para botones de cantidad (+ y -)
$(document).on('click', '.js-cart-items .c-quantity__button', async function(e) {
  e.preventDefault();
  
  const $button = $(this);
  const $quantityInput = $button.siblings('.js-quantity-input');
  const $item = $button.closest('.js-cart-min-item');
  
  // No permitir cambios en productos gratis
  if ($item.hasClass('free-item__mini')) {
    return;
  }
  
  const lineId = $item.attr('data-line-id');
  const productId = $item.attr('data-product-id');
  const promoProducts = $item.attr('data-product-promo') || '';
  const currentQuantity = parseInt($quantityInput.val()) || 0;
  const isPlus = $button.attr('name') === 'plus';
  const newQuantity = isPlus ? currentQuantity + 1 : currentQuantity - 1;
  
  // Si la cantidad es 0 o menor, eliminar el producto
  if (newQuantity <= 0) {
    await updateMiniCartLine(lineId, 0, productId, promoProducts);
  } else {
    // Actualizar la cantidad
    await updateMiniCartLine(lineId, newQuantity, productId, promoProducts);
  }
});

// Event delegation para botón de eliminar
$(document).on('click', '.js-cart-min-remove', async function(e) {
  e.preventDefault();
  
  const $button = $(this);
  const lineId = $button.attr('data-line-id');
  const $item = $button.closest('.js-cart-min-item');
  const productId = $item.attr('data-product-id');
  const promoProducts = $item.attr('data-product-promo') || '';
  
  if (!lineId) {
    console.error('No se encontró el line-id');
    return;
  }
  
  // Eliminar el producto (cantidad = 0)
  await updateMiniCartLine(lineId, 0, productId, promoProducts);
});

// Event listener para el input de cantidad cuando cambia manualmente
$(document).on('change', '.js-cart-items .js-quantity-input', async function(e) {
  const $input = $(this);
  const $item = $input.closest('.js-cart-min-item');
  
  // No permitir cambios en productos gratis
  if ($item.hasClass('free-item__mini') || $input.is(':disabled')) {
    return;
  }
  
  const lineId = $item.attr('data-line-id');
  const productId = $item.attr('data-product-id');
  const promoProducts = $item.attr('data-product-promo') || '';
  const newQuantity = parseInt($input.val()) || 0;
  
  await updateMiniCartLine(lineId, newQuantity, productId, promoProducts);
});